import moment from 'moment'
import client from '@stores/apollo'
import gql from 'graphql-tag'
import { EmployeeDetailsFragment } from '@api/fragments'
import { IEmployeeDetails } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

export interface ICreateEmployeeInput {
  name: string
  title: string
  managerId: string
  email: string
  phone: string
  departmentId: string
  employmentType: string
  geoLocationId: string
  startDate: string | null
  endDate: string | null
  badge: string
}

interface IPayload {
  createEmployee: {
    employee: IEmployeeDetails
  }
}

const mutateHandler = handleFetchResult<IPayload, IEmployeeDetails>({
  handler: (data) => {
    const { employee } = data.createEmployee
    return {
      ...employee,
      startDate: employee.startDate ? moment(employee.startDate).toDate() : null,
      endDate: employee.endDate ? moment(employee.endDate).toDate() : null,
    }
  },
  name: 'Employee',
})

export default function create(input: ICreateEmployeeInput): Promise<IEmployeeDetails> {
  return client.gql
    .mutate({ mutation, variables: { input, assignmentPlanId: null } })
    .then(mutateHandler)
}

const mutation = gql`
  mutation CreateEmployee($input: CreateEmployeeInput!, $assignmentPlanId: ID) {
    createEmployee(input: $input) {
      employee {
        ...EmployeeDetailsFragment
      }
    }
  }
  ${EmployeeDetailsFragment}
`
